import { upperFirst } from 'lodash-es';

import { RoleEnum } from 'src/common/external/bambi-api/bambiApi';

export function formatUserType(userType: RoleEnum) {
  return userType.split(' ').map(upperFirst).join(' ');
}
